import React from 'react';
import ProgressIndicatorSpinnerIconMedium from './ProgressIndicatorSpinnerIconMedium';
import ProgressIndicatorSpinnerIconSmall from './ProgressIndicatorSpinnerIconSmall';
const ProgressIndicatorSpinnerIcon = ({ size = 'medium', ...props }) => size === 'medium' ? React.createElement(ProgressIndicatorSpinnerIconMedium, { ...props }) : React.createElement(ProgressIndicatorSpinnerIconSmall, { ...props });
export default ProgressIndicatorSpinnerIcon;
//# sourceMappingURL=ProgressIndicatorSpinnerIcon.js.map